<template>
    <div v-if="!hidden" style="width: 100%">
        <swiper class="swiper" :options="swiperOptionTop" ref="swiperTop" style="width: 80%;">
            <swiper-slide v-for="(type, key) in getTypes()" :key="key" class="slide">
                <label :for="'types-' + type.value" class="custom-checkbox bg-light-grey rounded-lg swiper-card" :style="backgroundImageStyle(type.image)">
                <input v-model="filters" :value="type.value" class="form-input-checkbox hidden-checkbox" type="checkbox"
                    :name="'types-' + type.value" :id="'types-' + type.value">
                </label>
                <p class="text-center" style="width: 81px;" :for="'types-' + type.value">{{ type.name }}</p>
            </swiper-slide>
        </swiper>
        <div class="swiper-button-prev swiper-button-prev-featured" slot="button-prev">
            <span class="tx-30 tx-lightgrey-1"><i class="fas fa-chevron-left"></i></span>
        </div>
        <div class="swiper-button-next swiper-button-next-featured" slot="button-next">
            <span class="tx-30 tx-lightgrey-1"><i class="fas fa-chevron-right"></i></span>
        </div>
    </div>
    <div v-else class="filters__bit">
        <div class="title trigger-collapse trigger-types" @click="loadTypes">
            <span class="filter-title"> Tipo </span>
            <img class="icon-dropdown float-right" src="/assets/images/helpers/icon-dropdown.svg" alt="">
        </div>
        <div class="collapse">
            <div class="wrap_big_list">
                <ul class="list__bit grid__bit p-0 bullet-none mt-0 mb-7">
                    <li v-for="(type, key) in getTypes()" :key="'types-' + type.value" :class="limitTypes <= key && !allTypes ? 'hidden' : ''" class="item">
                        <input v-model="filters" :value="type.value" class="form-input-checkbox hidden" type="checkbox"
                        :name="'types-' + type.value" :id="'types-' + type.value">
                        <label :for="'types-' + type.value" class="checkbox-mark">
                            {{ type.name }}
                        </label>
                    </li>
                </ul>
            </div>
            <a v-if="!allTypes" class="tx-14 tx-grey-1 underline opacity-60" href="" @click="moreTypes($event)">
                Mostrar más tipos de vehículos
            </a>
        </div>
    </div>
</template>

<script>
import {mapActions, mapState} from 'vuex';
import { Swiper, SwiperSlide } from 'vue-awesome-swiper';
import 'swiper/css/swiper.css';
export default {
    props: {
        hidden: {
            type: Boolean,
            default: true
        }
    },
    data: () => ({
        filters: [],
        allTypes: false,
        limitTypes: 6,
        swiperOptionTop: {
                lazy: true,
                slidesPerView: 1,
                spaceBetween: 4,
                loop: false,
                // loopFillGroupWithBlank: true,
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev'
                },
                breakpoints: {
                    320: {
                        slidesPerView: 2
                    },
                    375: {
                        slidesPerView: 3,
                        spaceBetween: 6
                    },
                    768: {
                        slidesPerView: 4,
                        spaceBetween: 12
                    },
                    1280: {
                        slidesPerView: 6,
                        spaceBetween: 12
                    }
                }
        },
    }),
    components: {
        "swiper": Swiper,
        "swiper-slide": SwiperSlide
    },
    computed : {
        ...mapState('catalog',['productType']),
    },

    watch: {

        'filters': {
            handler(newValue){
                let vm = this;
                this.$emit('change', 'types', newValue);
            }, deep: true
        },

    },
    async mounted() {
        await this.getProductTypes();
    },
    methods: {
        ...mapActions('catalog',['getProductTypes']),

        getTypes() {
            return _.map(this.productType, function(item, key) {
                return {
                    name: item.title,
                    value: item.id,
                    image: item.image
                };
            });
        },
        loadTypes () {
            this.getProductTypes()
        },
        moreTypes(event) {
            let vm = this;
            event.preventDefault();
            vm.allTypes = true;
        },
        backgroundImageStyle(image) {
            return {
                backgroundImage: `url(/assets/images/vehicleTypes/${image})`
            }
        }
    }
}
</script>
<style scoped>
.swiper-button-prev {
    left: 1.5rem;
}
.swiper-button-next {
    right: 1.5rem;
}
.swiper-button-prev, .swiper-button-next {
    top: 1%;
}
.rounded-lg {
    border-radius: 50%;
}
.swiper-card {
    width: 85px;
    height: 85px;
    display: flex;
    align-items: center;
    justify-content: center;
}
.hidden-checkbox {
    position: absolute;
    opacity: 0;
    width: 0;
    height: 0;
}

.custom-checkbox {
    display: inline-block;
    width: 81px;
    height: 81px;
    background-size: cover;
    cursor: pointer;
}

.hidden-checkbox:checked + .custom-checkbox {
    /* background-image: url('checkbox-checked.png'); */ /* Imagen del checkbox marcado */
}
@media screen and (max-width: 1024px) {
    .swiper-button-prev, .swiper-button-next {
        top: 1%;
    }
}
@media screen and (max-width: 768px) {
    .card-img {
        height: 180px;
    }
    .swiper-button-prev, .swiper-button-next {
        top: 1%;
    }
}
@media screen and (max-width: 425px) {
    .swiper-button-prev, .swiper-button-next {
        top: 0.5%;
    }
    .swiper-container {
        top: 1rem;
    }
}
</style>
